import React from 'react';
import _ from 'lodash';
import { Link } from '@jutro/components';
import { ImageComponent } from 'gw-components-platform-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import styles from './CMSComponent.module.scss';

function CMSComponent(props) {
    const { bannerList } = props;
    const CMSLink = _.get(appConfig, `tdic.CMSLink.${process.env.NODE_ENV}`,
        _.get(appConfig, 'tdic.CMSLink.development', ''));

    return bannerList.map((banner) => {
        return (
            <div className={styles.tdicCMSContainer}>
                <Link
                    href={banner.Link === '' ? _.noop() : banner.Link}
                    title={banner.Title}
                    target="_blank"
                    className={styles.fillContent}
                >
                    <ImageComponent
                        src={`${CMSLink}${banner.ImagePath}`}
                        alt={banner.ImageAlt}
                        title={banner.Title}
                        className={styles.cmsImage}
                    />
                </Link>
            </div>
        );
    });
}

export default CMSComponent;
